import { gsap } from 'gsap'
import { deepMerge } from 'js/utils/Utils'
import BaseMenu from 'js/modules/_base/navigation/menu/BaseMenu'

const defaults = {
  instanceName: 'ganymedeMenu',
  $names: {
    trigger: '[data-header-btn-menu]',
    target: '[data-header-nav]',
  },
}

export default class GanymedeMenu extends BaseMenu {
  constructor(options = {}) {
    super()
    deepMerge(this, defaults, options)

    this.callback = {
      open: async () => {
        await new Promise((resolve) => {
          if (this.$target) {
            this.$target.style.display = 'block'

            gsap.killTweensOf(this.$target, 'opacity')

            this.$target.scrollTop = 0

            gsap.to(this.$target, {
              opacity: 1,
              onComplete: () => {
                resolve()
              },
            })
          }
        })
      },
      close: async (isTransition) => {
        await new Promise((resolve) => {
          if (this.$target) {
            gsap.killTweensOf(this.$target, 'opacity')
            gsap.to(this.$target, {
              opacity: 0,
              onComplete: () => {
                this.$target.style.display = 'none'
                resolve()
              },
            })
          }
        })
      },
    }
  }

  init() {
    super.init()
  }

  destroy() {
    super.destroy()
  }
}